import { jwtDecode } from "jwt-decode";

// Make sure jwt-decode is installed
import { JWTClaims } from "../types/JWTTypes";

export const allowedPathsByTokenType = {
  inOfficeForms: ["/forms", "/forms/complete"],
  staffAccessForms: ["/forms", "/forms/complete"],
  telemedicine: [],
  appointmentMoveUp: ["/moveUpAppointmentPage"],
};

// Add other claim types here if needed in the future
// interface OtherClaims extends JwtPayload { ... }

/**
 * Decodes a JWT token and performs basic client-side validation.
 * NOTE: This does NOT verify the token signature (that must be done backend).
 * It primarily checks for expiration and decodes the payload.
 *
 * @param token The JWT token string.
 * @returns The decoded payload if the token is valid and not expired, otherwise null.
 */
export const decodeAndValidateToken = (token: string | null): JWTClaims | null => {
  if (!token) {
    return null;
  }

  try {
    const decoded = jwtDecode<JWTClaims>(token);

    // Check for expiration
    if (decoded.exp && decoded.exp * 1000 < Date.now()) {
      console.warn("Token expired");
      return null; // Token is expired
    }

    // Basic structure check (can add more specific checks if needed)
    if (!decoded.type || !decoded.id) {
      console.error("Token missing essential claims");
      return null;
    }

    return decoded;
  } catch (error) {
    console.error("Failed to decode token:", error);
    return null; // Token is invalid or malformed
  }
};
